import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthorization } from './authorizationHooks'

/**
 * Route-level guard for ``org_admin``-only pages (e.g. ``/admin``).
 *
 * Distinct from {@link PermissionGuard} because it needs different behavior
 * for loading vs unauthorized states:
 *  - while permissions are still being fetched, render nothing so legitimate
 *    admins are not briefly flashed to ``/orders`` (and stale-role admins from
 *    a previous session are not shown the Admin shell during the resolve).
 *  - once permissions resolve without ``org_admin``, redirect to ``/orders``
 *    so the URL bypass discovered in GEN-3078 cannot reach the Admin page.
 */
export function RequireOrgAdmin({ children }: { children: ReactNode }) {
  const { hasRole, isLoading } = useAuthorization()
  if (isLoading) return null
  if (!hasRole('org_admin')) return <Navigate to="/orders" replace />
  return <>{children}</>
}
